// platform-specific versions are used to prevent layout and styling issues with SVG components on different platforms.

export { default } from 'react-content-loader';
